/**
 * WebAuthn RP IDs must be a registrable domain. Browsers reject bare IPs
 * (SecurityError: "This is an invalid domain") — including 127.0.0.1.
 * `localhost` is the special-case exception for local IdP enroll.
 */
export function isWebAuthnHostileHost(hostname: string): boolean {
  const h = hostname.trim().toLowerCase()
  if (!h) return false
  if (h === 'localhost') return false
  // IPv4
  if (/^\d{1,3}(\.\d{1,3}){3}$/.test(h)) return true
  // IPv6 / bracketed
  if (h.includes(':')) return true
  return false
}

/** True when the current page or configured Keycloak URL would break passkeys. */
export function webAuthnNeedsLocalhost(
  pageHost: string,
  keycloakBaseUrl: string | undefined,
): boolean {
  if (isWebAuthnHostileHost(pageHost)) return true
  if (!keycloakBaseUrl) return false
  try {
    return isWebAuthnHostileHost(new URL(keycloakBaseUrl).hostname)
  } catch {
    return false
  }
}
